import React, {useState, Fragment} from 'react';
import { Card, CardContent } from '@mui/material';
import { NavigateNext, Visibility } from '@mui/icons-material';
import { setearDatosAlStore, obtenerRegistrosPorURL } from 'store/actions/customAction';
import { useDispatch } from 'react-redux';
import { nombreDeAcciones } from 'constantes/nombreDeAcciones';
import Formulario from 'components/formulario';
import Base64Pdf from 'components/base64pdf';
import { functions } from 'constantes/functions';

const DatosDeLaEmpresa = ({activeStep, numberStep, datosDeEmpresa, idSolicitud}) => {
    const dispatch = useDispatch();
    const { archivoPatenteComercio, correoElectronico, correoElectronicoMedio, direccionEmpresa, direccionNotificaciones, folio, libro, nombreEmpresa, nombreEnlace, patente, registro, telefono, telefono2, telefonoMedio, tipoPropietario, declaracionJurada, archivoTimbre, NumeroRegistro, FechaVigencia, FechaInscripcion, solvenciaTimbre} = datosDeEmpresa;

    const [docAdjunto, setDocAdjunto] = useState({title: '', pdf: ''});
    const [mostrarDoc, setMostrarDoc] = useState(false);

    const cerrarDoc = () => setMostrarDoc(false);
    const descargarDoc = () => functions.descargarBase64EnPDF(docAdjunto.pdf, `${docAdjunto.title}.pdf`);

    const obtenerPDFDelServidor = async (tipoDeArchivo) => {
        const respuesta = await dispatch(obtenerRegistrosPorURL({
            controller: 'formularioDeRegistroDeMediosDeComunicacion',
            saveInStore: false,
            nombreDelMetodo: `obtenerArchivo/${tipoDeArchivo}`,
            parametro: idSolicitud
        }));
        if (!respuesta?.data) return;
        setDocAdjunto({title: tipoDeArchivo, pdf: respuesta.data});
        setMostrarDoc(true);
    };

    const convertirMayusculas = (data) => {
        const nuevo = {};
        Object.keys(data).forEach((key) => {
            if (typeof data[key] === 'string' && !data[key].startsWith('data:')) {
                nuevo[key] = data[key].toUpperCase();  
            } else {
                nuevo[key] = data[key];
            }
        });
        return nuevo;
    };

    const [elementosDelFormulario] = useState(() => {
        const elementos = {
        companyDataTitle:{
            idelement: "companyDataTitle", title:'Datos de la Empresa', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "titleBusquedaNit",
        },
        nombreEmpresa: {
            idelement: "nombreEmpresa",  value: nombreEmpresa, label: "Nombre de la empresa *",  pattern:"^([a-zA-Z0-9_À-ÿñÑ',&-\.\/]{1,})([ ][a-zA-Z0-9_À-ÿñÑ',&-\.\/]{1,}){0,}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto',  autofocus: true, name:"nombreEmpresa", 'disabled': !!nombreEmpresa && !idSolicitud,
        },
        contactoDeEmpresa:{
            idelement: "contactoDeEmpresa",title:'Datos de contacto de la empresa', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "titleBusquedaNit",
        },
        direccionEmpresa: {
            idelement: "direccionEmpresa",  value: direccionEmpresa, label: "Ingrese dirección de la empresa *", pattern:"^([\\w_][\\w_ -.\"\'ÑñwáéíóúÁÉÍÓÚ]*[\\w_.\"\'ÑñwáéíóúÁÉÍÓÚ]){1,65}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto',  autofocus: false,
        },
        direccionNotificaciones: {
            idelement: "direccionNotificaciones",  value: direccionNotificaciones, label: "Dirección para recibir notificaciones *", pattern:"^([\\w_][\\w_ -.\"\'ÑñwáéíóúÁÉÍÓÚ]*[\\w_.\"\'ÑñwáéíóúÁÉÍÓÚ]){1,65}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto',  autofocus: false,
        },
        correoElectronico: {
            idelement: "correoElectronico", value: correoElectronico, label: "Correo electrónico *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', name:"correoElectronico"
        },
        telefono: {
            idelement: "telefono",  value: telefono, label: "Teléfono 1 *", pattern:"^[0-9]{8}$", validators: ['required'], errorMessages:['Numérico de 8 digitos'], isError:false, elementType:'texto', autofocus: false, name:"telefono"
        },
        telefono2: {
            idelement: "telefono2",  value: telefono2, label: "Teléfono 2 ", pattern:"^[0-9]{0,8}$", validators: [], errorMessages:['Numérico de 8 digitos'], isError:false, elementType:'texto', autofocus: false, name:"telefono2"
        },
        DatosDelTse:{
            idelement: "DatosDelTse",title:'Datos enlace de medio con TSE', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "titleBusquedaNit",
        },
        nombreEnlace: {
            idelement: "nombreEnlace",  value: nombreEnlace, label: "Nombre *", pattern:"^([a-zA-ZÀ-ÿñÑ\.]{1,})([ ][a-zA-ZÀ-ÿñÑ\.]{1,}){0,}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name:"nombreEnlace"
        },
        correoElectronicoMedio: {
            idelement: "correoElectronicoMedio", value: correoElectronicoMedio, label: "Correo electrónico *", pattern:"^[\\wA-Z0-9._%+-]+@[\\wA-Z0-9.-]+\\.\\w{2,4}$", validators: ['required'], errorMessages:['Ingrese un correo válido'], isError:false, elementType:'texto', autofocus: false, name:"correoElectronicoMedio"
        },
        telefonoMedio: {
            idelement: "telefonoMedio",  value: telefonoMedio, label: "Teléfono 1 *", pattern:"^[0-9]{8}$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name:"telefonoMedio"
        },
        patenteComercio:{
            idelement: "patenteComercio",title:'Detalle patente de comercio', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true, name: "patenteComercio",
        },
        patente: {
            idelement: "patente",  value: patente, label:"Número de expediente *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name: "patente",
        },
        registro: {
            idelement: "registro",  value: registro, label: "Número de registro *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'], errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name: "registro",
        },
        folio:{
            idelement: "folio", value: folio, label: "Folio *",pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name: "folio",
        },
        libro:{
            idelement: "libro", value: libro, label: "Libro *", pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name: "libro",
        },
        archivoPatenteComercio:{
            idelement: "archivoPatenteComercio", value: archivoPatenteComercio, label: "Ingrese en PDF la patente de comercio *",
            validators: {required: idSolicitud ? false : true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"archivoPatenteComercio", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Archivo patente", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFDelServidor('patenteDeComercio') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
    
        declaracionJurada:{
            idelement: "declaracionJurada", value: declaracionJurada, label: "Ingrese en PDF la declaración jurada *",
            validators: {required: idSolicitud ? false : true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"declaracionJurada", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Declaración jurada", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFDelServidor('declaracionJurada') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        DatosTimbre:{
            idelement: "DatosTimbre",title:'Registro de timbre de prensa', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true,  name: "titleBusquedaNit",
        },
        NumeroRegistro:{
            idelement: "NumeroRegistro", value: NumeroRegistro, label: "Código de inscripción *",pattern:"^[\-0-9_\/|a-zA-Z]+$", validators: ['required'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'texto', autofocus: false, name: "NumeroRegistro",
        },
        FechaInscripcion:{
            idelement: "FechaInscripcion", value: FechaInscripcion || null, label: "Fecha de inscripción *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required', 'pattern'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'fecha', disabled: false, showInputDate: true, name: "FechaInscripcion",
            invalidDateErrorMessages: ['Ingrese una fecha válida con formato dd/mm/yyyy'],
        },
        FechaVigencia:{
            idelement: "FechaVigencia", value: FechaVigencia || null, label: "Fecha de solvencia *", pattern:"^[0-9]{1,2}[/][0-9]{1,2}[/][0-9]{4}$", validators: ['required', 'pattern'],
            errorMessages:['El campo es requerido'], isError:false, elementType:'fecha', disabled: false, showInputDate: true, name: "FechaVigencia",
            invalidDateErrorMessages: ['Ingrese una fecha válida con formato dd/mm/yyyy'],
        },
        saltoArchivosTimbre: {
            idelement: "saltoArchivosTimbre", width: '100%', marginBottom: '0px', showAlertForm: false, elementType: 'alerta',
        },
        archivoTimbre:{
            idelement: "archivoTimbre", value: archivoTimbre, label: "Ingrese en PDF la constancia del registro de prensa",
            validators: {required: idSolicitud ? false : true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"archivoTimbre", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Archivo timbre", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFDelServidor('archivoTimbre') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        solvenciaTimbre:{
            idelement: "solvenciaTimbre", value: solvenciaTimbre, label: "Ingrese en PDF la solvencia de pago de timbre*",
            validators: {required: idSolicitud ? false : true,  size: "10 MB",}, errorMessages: 'Por favor debe adjuntar lo solicitado', isError:false, elementType:'archivo','disabled':false, name:"solvenciaTimbre", fileWidth: true, src: '', multiple: false, accept:".pdf", showInMovil: true, type: "file", showButtonEditDocument: true, firstTitle: "Archivo timbre", iconButton: <Visibility />, handleVisualization: idSolicitud ? () => obtenerPDFDelServidor('solvenciaTimbre') : () => {}, nameOfFile: idSolicitud ? 'Archivo guardado en servidor' : undefined, disabledVisualization: !!idSolicitud, fileType: "pdf"
        },
        tipoPropietarioTitle:{
            idelement: "tipoPropietarioTitle",title:'Elija el tipo de propietario', position:"center", value: "", isError:false, elementType:'titulo', showTitleForm: true, name: "tipoPropietarioTitle",
        },
        tipoPropietario:{
            idelement: "tipoPropietario", value: tipoPropietario, label: "Elija el tipo de propietario", isError:false, elementType:'radio', errorMessages:['Debe seleccionar una opción'],
            options : [ { value: '1', label: 'Persona Individual' }, { value: '0', label: 'Persona Jurídica' }, ], 'disabled': idSolicitud ? true : false, isRequired: true
        },
        };

        Object.keys(elementos).forEach((key) => {
            if (["texto", "areaTexto"].includes(elementos[key]?.elementType)) {
                elementos[key].transformToUppercase = true;
            }
        });

        return elementos;
    });

    const saveData = (dataForm) => {
        const dataMayus = convertirMayusculas(dataForm);
        dispatch(setearDatosAlStore({
            dispatchAction : nombreDeAcciones.SET_DATA_COMPANY,
            data: {
                company: dataMayus,
                activeStep : activeStep + 1,
                numberStep : numberStep + 1
            }
        }));
    }

    const [listadoDeBotones]= React.useState({
        "saveData":{"label":"Siguiente", "icon": <NavigateNext />, "callback":saveData,"loading":false,"size":"medium",
                "background":"linear-gradient(45deg, #205690 30%, #3890EE 90%)", "border":"0px", "borderRadius":"3",
                "boxShadow":"0 3px 5px 2px rgba(33, 203, 243, .3)", "color":"white", "height":37, padding:"0 30px", disabled: false,
                isCancel: false,
        },
    });

    return (
        <Fragment>
            <Card>
                <CardContent>
                    <Formulario
                        elements={elementosDelFormulario}
                        buttonList={listadoDeBotones}
                    />
                </CardContent>
            </Card>
            {mostrarDoc && (
                <Base64Pdf pdf={docAdjunto.pdf} title={docAdjunto.title} open={mostrarDoc} handleClose={cerrarDoc} showDownloadButton={true} src={docAdjunto.pdf} DescargarPDF={descargarDoc} />
            )}
        </Fragment>
    );
}

export default DatosDeLaEmpresa;